/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeWhiteMenuItemCheck } from "./d-theme-white-menu-item-check";

export class DThemeWhiteMenuSidedItemCheck extends DThemeWhiteMenuItemCheck {}
